import React from 'react';

import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { _ } from '../../../functions/translator';
import { objectIsNotEmpty } from '../../../functions/utils';
import { getUsername } from '../../../functions/getter';
import { getData } from '../../../functions/getData';
import { CircularProgress } from '@material-ui/core'

class SignaturesInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: {},
            loading: true
        };
    }

    async componentDidMount() {
        const userDataPromises = [];

        for (const cardData of Object.values(this.props.cardsGroup.cards)) {
            if (this.props.cardId && this.props.cardId !== cardData.id) continue;
            if (!objectIsNotEmpty(cardData.signatures)) continue;

            for (const signatureData of Object.values(cardData.signatures)) {
                const URL = {
                    method: 'GET',
                    value: `/web-api/users/${signatureData.attributes.user_id}`
                };
                const userData = await getData(URL)
                userDataPromises.push(userData);
            }
        }

        const userDataArray = await Promise.all(userDataPromises);
        const userData = userDataArray.reduce((acc, data) => {
            if (data) {
                acc[data.id] = data;
            }
            return acc;
        }, {});

        this.setState({ userData, loading: false });
    }

    render() {
        if (this.state.loading) {
            return <div className='info-container mw-100'>
                        <CircularProgress style={{ width:'20px', height:'20px' }} />
                    </div>
        }

        if (!objectIsNotEmpty(this.props.cardsGroup.cards)) return null;
        const signedUserIds = [];
        const signaturesInfo = [];

        for (const cardData of Object.values(this.props.cardsGroup.cards)) {
            if (this.props.cardId && this.props.cardId !== cardData.id) continue;
            if (!objectIsNotEmpty(cardData.signatures)) continue;

            for (const signatureData of Object.values(cardData.signatures)) {
                const userData = this.state.userData[signatureData.attributes.user_id];
                if (!userData) continue;
                if (signedUserIds.includes(signatureData.attributes.user_id)) continue;
                signedUserIds.push(signatureData.attributes.user_id);

                const firstName = userData.attributes.first_name;
                const lastName = userData.attributes.last_name;
                const userName = getUsername(signatureData.attributes.user_id, this.props.usersData);
                const avatarSrc = `https://ui-avatars.com/api/?name=${firstName} ${lastName}&size=128`;
                signaturesInfo.push(
                    <div className='m-2 small' key={signatureData.attributes.user_id}>
                        <Chip avatar={<Avatar src={avatarSrc} />} label={userName} />
                    </div>
                );
            }
        }

        return (
            <div className='info-container mw-100'>
                <p className='card-text'>{_("Firmas")}</p>
                <div className='d-flex flex-wrap'>
                    {signaturesInfo.length ? signaturesInfo : <p>{_('Sin')} {_('Firmas')}</p>}
                </div>
            </div>
        );
    }
}

export default SignaturesInfo;